<template>
    <div id="contenedor-catalogos-main">
      <router-view />
    </div>
</template>

<script>
export default {
  name: 'CatalogosMain',
  data() {
    return {};
  },
  mounted() {
    // console.log('CatalogosMain');
  },
};
</script>

<style lang="scss">

</style>
